/**
 * Skill-tag vocabulary for per-photo tagging in the Teaching Facilitation flow.
 *
 * These five skills mirror the facilitation prompts in phase 5 of the lesson
 * (DESCRIBE / PRAISE / REFLECT / RELATE / CARE). Teachers tag photos with the
 * skill(s) that best capture what they noticed in a child's work.
 */

import type { SkillTag } from '../../lib/teachingSession';

export const SKILL_TAGS: SkillTag[] = ['describe', 'praise', 'reflect', 'relate', 'care'];

export const SKILL_TAG_LABELS: Record<SkillTag, { en: string; es: string }> = {
  describe: { en: 'Describe', es: 'Describir' },
  praise: { en: 'Praise', es: 'Elogiar' },
  reflect: { en: 'Reflect', es: 'Reflejar' },
  relate: { en: 'Relate', es: 'Relacionar' },
  care: { en: 'Care', es: 'Cuidar' },
};

export const SKILL_TAG_COLORS: Record<SkillTag, { bg: string; fg: string; ring: string }> = {
  describe: { bg: '#e0f2fe', fg: '#075985', ring: '#0284c7' }, // sky
  praise: { bg: '#fef3c7', fg: '#92400e', ring: '#f59e0b' }, // amber
  reflect: { bg: '#e9d5ff', fg: '#6b21a8', ring: '#9333ea' }, // purple
  relate: { bg: '#fce7f3', fg: '#9d174d', ring: '#db2777' }, // pink
  care: { bg: '#e6f4ec', fg: '#2a6d5b', ring: '#42a57a' }, // green (wonder little)
};
